import { useTranslation } from 'react-i18next';

import { MenuIncident } from '../Menu/MenuIncident';
import { Layout } from './components/Layout';
import { useLayoutContext } from './model/LayoutProvider';

export const LayoutIncident = () => {
  const { t } = useTranslation();
  const { hideNavigation } = useLayoutContext();
  return <Layout menu={<MenuIncident hideNavigation={!hideNavigation} />} headerName={t('ims')} />;
};
